import { Link, withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ChatIcon from '@material-ui/icons/Chat';
import FlagIcon from '@material-ui/icons/Flag';
import IconButton from '@material-ui/core/IconButton';
import React, { useEffect } from 'react';
import SimpleImageLoader from '../Atoms/SimpleImageLoader';
import SimpleMenu from '../Atoms/SimpleMenu/SimpleMenu';
import Typography from '@material-ui/core/Typography';
import * as routines from '../../Containers/Moments/momentRoutines'
import {useDispatch} from "react-redux";
import MomentCreateOrUpdate from "./MomentCreateOrUpdate";
const useStyles = makeStyles((theme: any) => ({
    avatar: {
        backgroundColor: red[500],
    },
    cardContent: {
        padding: 0
    },
    cardHeader: (post: any) => ({
        backgroundColor: post.removedByAdmin ? 'red' : theme.palette.primary.main,
        color: theme.palette.common.white,
    }),

    description: {
        color: theme.palette.common.black,
        fontWeight: 400,
        minHeight: '25px',
        paddingLeft: theme.spacing(1),
        textAlign: 'left',
    },
    expand: {
        marginLeft: 'auto',
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    flag: (post: any) => ({
        color: post.removedByAdmin === undefined || post.removedByAdmin === true ? 'red' : 'green',
    }),
    headerAction: {
        '& :hover': {
            color: theme.palette.common.white,
        },
        color: theme.palette.common.white,
    },
    media: {
        height: '100%',
        marginBottom: theme.spacing(1),
        width: '100%',
    },
    root: {
        cursor: 'pointer',
        flex: 1,
        padding: '0',
    },
    subheader: {
        color: theme.palette.common.white,
    },
}));

const Moment = (props: any) => {
    const [editMode, setEditMode] = React.useState(false)
    const { fetchUserAvatar, post, remove } = props;
    let name = post.senderName || post.authorName || '';
    const classes = useStyles(post);
    let userId = post.authorId || post.senderId;

    const dispatch = useDispatch();
    useEffect(() => {
        fetchUserAvatar(userId);
    }, [userId, fetchUserAvatar]);

    const handleDialogClose = () =>{
        setEditMode(false)
    }
    const handleUpdate = (obj: {imageURL: string, text: string}) => {
        setEditMode(false)
        dispatch(routines.updateMoment({...obj, id: post.id}))
    }

    const handleRemove = () => {
        remove({
            id: post.id,
            removedByAdmin: !post.removedByAdmin,
        });
    };

    const handleContentClick = () =>{
      return props.onClick ? props.onClick() : false
    }
    const ActionButtons = () =>{
        return (
            <>
                <Link to={`${props.location.pathname}/${post.id}`}>
                    <IconButton aria-label="View flagged comments" color="secondary">
                        <Badge badgeContent={post.flaggedComments ? post.flaggedComments : ''}>
                            <FlagIcon />
                        </Badge>
                    </IconButton>
                </Link>
                <Link to={`${props.location.pathname}/${post.id}`}>
                    <IconButton aria-label="View comments" color="secondary">
                        <Badge badgeContent={post.comments ? post.comments.length : ''}>
                            <ChatIcon />
                        </Badge>
                    </IconButton>
                </Link>
            </>
        )
    }

    return (
        <React.Fragment>
            <Card  classes={{ root: classes.root }} data-cy="Moment" data-removedByAdmin={post.removedByAdmin}>
                <MomentCreateOrUpdate post={post} title={'Update moment'} updateMode={true} handleClose={handleDialogClose} handleSave={handleUpdate} open={editMode}/>

                <CardHeader
                    action={
                      !editMode && <SimpleMenu
                            mode="dark"
                            options={[
                                {

                                    callback: ()=>setEditMode(true),
                                    label: "Edit"
                                },
                                {
                                    callback: handleRemove,
                                    label: post.removedByAdmin ? 'Make post visible' : 'Remove post',
                                },
                            ]}
                        />
                    }
                    avatar={
                        <Avatar color="primary">
                            {post.avatar ? <img alt="user avatar" src={post.avatar} width="40" /> : `${name.charAt(0)}`}
                        </Avatar>
                    }
                    classes={{ action: classes.headerAction, root: classes.cardHeader, subheader: classes.subheader }}
                    subheader={post.friendlyTimeStamp}
                    title={post.authorName}
                />
                    <CardContent onClick={handleContentClick} classes={{ root: classes.cardContent }}>
                        <SimpleImageLoader alt="Moment" className={classes.media} src={post.content} width={300} />
                     <Typography  className={classes.description} color="textSecondary" component="p" variant="body2">
                            {post.description}
                        </Typography>
                    </CardContent>
                <CardActions>
                  <ActionButtons/>
                </CardActions>
            </Card>
        </React.Fragment>
    );
};
export default withRouter(Moment);
